import { gql } from "@apollo/client";

export const DashboardQueries = {
  GET_STATIC_SITE_DETAILS: gql`
    query GET_STATIC_SITE_DETAILS($domain: String!) {
      authoring_getStaticSiteDetails(domain: $domain) {
        staticSiteStatus
        isBackupRestored
        isStaticSiteBackup
        userInfo
        createdAt
        updatedAt
      }
    }
  `,

  GENERATE_STATIC_SITE: gql`
    mutation authoring_staticSiteTrigger($input: authoring_staticSiteTriggerInput) {
      authoring_staticSiteTrigger(input: $input) {
        message
      }
    }
  `,
};
